import axiosInstance from './axiosInstance';

const getSubsidies = (filters = {}) => {
  const {
    perPage,
    page,
    column,
    orderColumn,
    alias,
    status,
    address,
    creatorId,
  } = filters;

  return axiosInstance.get('/internal/admin/subsidies', {
    params: {
      per_page: perPage,
      page,
      column,
      order_column: orderColumn,
      status,
      alias,
      address,
      creator_id: creatorId,
    },
  });
};

export default getSubsidies;
